import { IdentityBodyAssessMeasurement } from '@reg/shared/model';

/**
 * Model to hold a body assessment method (Caliper) and it's associated measurements (Chest, Triceps)
 */
export class IdentityBodyAssessMethod {
    public static ID_CALIPER_JACKSON_POLLOCK_4: string = '826f9e10-a7dc-d945-e054-9f4a4c5d9bcd';
    public static ID_CALIPER_JACKSON_POLLOCK_7: string = 'a0c8f53e-e220-4f34-a1a9-115fcdefb141';
    public static ID_MINIMUM_WEIGHT: string = 'c0b46bbb-f4b3-ff8a-b4e0-cb7cc782e0ea';

    public id: string = null;
    public name: string = null;
    public measurements: IdentityBodyAssessMeasurement[] = [];

    public clone(): IdentityBodyAssessMethod {
        const clone: IdentityBodyAssessMethod = new IdentityBodyAssessMethod();
        clone.id = this.id;
        clone.name = this.name;

        if (this.measurements) {
            clone.measurements = this.measurements.map((m: IdentityBodyAssessMeasurement) => m.clone());
        }

        return clone;
    }

    /**
     * Deserialize to json api format
     */
    public deserialize(json: Object, included: Object[] = null): IdentityBodyAssessMethod {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];
        included = included || json['included'];
        const relationships: Object[] = data['relationships'] || [];

        this.id = data['id'];
        this.name = attrs['name'];

        const measurementLinks: Object = relationships['bodyAssessmentMeasurements'];
        if (measurementLinks &&
            included &&
            measurementLinks['data']) {
            this.measurements = [];

            for (const personLink of measurementLinks['data']) {
                const measurement: Object = included.filter((i: Object) => i['id'] === personLink['id'])[0];
                if (measurement) {
                    this.measurements.push((new IdentityBodyAssessMeasurement()).deserialize(measurement, included));
                }
            }
        }

        return this;
    }
}
